import { useFlpAccess } from 'automation-ui-permissions/flp/hooks/useFlpAccess';
import { jsx as _jsx } from "react/jsx-runtime";
const withFlpAccess = WrappedComponent => props => {
  const {
    data,
    loading,
    error
  } = useFlpAccess(props.flowId);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    flpAccessLoading: loading,
    flpAccessError: error,
    flpAccessData: data
  }));
};
export default withFlpAccess;